// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2RO6U","header":"PatientBlock_header__Jn01C","label":"PatientBlock_label__3mC_r","option":"PatientBlock_option__1YcAm"};